module.exports = __webpack_public_path__ + "static/media/C20-0416_BTBMS_Homepage_en.22bef8b7.jpg";